export default __webpack_public_path__ + "static/media/valorant-agent.dc0bf921.png";